import { BaseColorProperties } from '../../lib/liveformseditor/common-items/BaseItem/base-item-properties';
import { InteractiveColorProperties } from '../../lib/liveformseditor/common-items/InteractiveItem/interactive-item-properties';

export const extractColorProperties = (
  properties: Record<string, any>
): BaseColorProperties & InteractiveColorProperties => {
  return {
    inputColor: properties['InputColor'] || '',
    textBgColor: properties['TextBgColor'] || ''
  };
};

export const DEFAULT_BG_COLOR = `#FFFFFFFF`;

export const getColors = (properties: BaseColorProperties | InteractiveColorProperties, isDarkMode = false) => {
  const textBgColor = 'textBgColor' in properties ? getArgbToRgba(properties.textBgColor) : DEFAULT_BG_COLOR;
  const textColor = getTextColor(textBgColor, isDarkMode);

  const inputBgColor = 'inputColor' in properties ? getArgbToRgba(properties.inputColor) : DEFAULT_BG_COLOR;
  const inputTextColor = getTextColor(inputBgColor, isDarkMode);

  return {
    textBgColor,
    textColor,
    inputBgColor,
    inputTextColor
  };
};

export function getTextColor(bgColor: string, isDarkMode = false) {
  if (!bgColor) {
    return isDarkMode ? '#FFFFFF' : '#000000';
  }

  const alpha = parseInt(bgColor.substring(7, 9), 16);

  if (alpha === 0) {
    return '#000000';
  }

  const r = parseInt(bgColor.substring(1, 3), 16);
  const g = parseInt(bgColor.substring(3, 5), 16);
  const b = parseInt(bgColor.substring(5, 7), 16);

  return isDarkColor(r, g, b) ? '#FFFFFF' : '#000000';
}

function isDarkColor(r: number, g: number, b: number): boolean {
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance < 0.5;
}

export function getArgbToRgba(color: string) {
  if (!color || !color.startsWith('#')) {
    if (color) {
      console.warn('color format not supported', color);
    }

    return `#FF000000`;
  }

  const A = color.substring(1, 3);
  const R = color.substring(3, 5);
  const G = color.substring(5, 7);
  const B = color.substring(7, 9);

  return `#${R}${G}${B}${A}`.toUpperCase();
}

export function getHexOrRgbaToArgb(color: string) {
  if (!color) {
    return '';
  }

  if (!color.startsWith('#')) {
    console.warn('color format not supported', color);
    return DEFAULT_BG_COLOR;
  }

  const R = color.substring(1, 3);
  const G = color.substring(3, 5);
  const B = color.substring(5, 7);
  const A = color.substring(7, 9) || 'FF';

  return `#${A}${R}${G}${B}`.toUpperCase();
}

export const getTextColorsPropertiesStyle = (textBgColor: string, textColor?: string) => {
  const textStyle: { [key: string]: string } = {};

  if (textBgColor) {
    textStyle['backgroundColor'] = textBgColor;
  }

  if (textColor) {
    textStyle['color'] = textColor;
  }

  return textStyle;
};

export const getInputStyle = (inputColor: string | null, inputTextColor?: string) => {
  const inputStyle: { [key: string]: string } = {};

  if (inputColor) {
    inputStyle['backgroundColor'] = inputColor;
  }

  if (inputTextColor) {
    inputStyle['color'] = inputTextColor;
  }

  return inputStyle;
};
